import React, { useEffect } from "react";
import "./WalletCard.css";
// import walletImg from "../assets/wallet.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetUserTransaction } from "../../../../features/admin/auth/Slice";

const WalletCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userTransaction = useSelector(
    (state) => state?.auth?.login?.getUserTransactionData,
  );

  useEffect(() => {
    dispatch(GetUserTransaction());
  }, [dispatch]);

  return (
    <div className="wallet-card" onClick={() => navigate("/wallet-history")}>
      <div className="wallet-left">
        <p className="wallet-label">Current Balance</p>
        <h2 className="wallet-amount">
          ₹ {userTransaction?.total_unpaid_amount}
        </h2>
        {/* <button className="wallet-btn">Payout</button> */}
      </div>

      <div className="wallet-right">
        <img src="images/profile/wallet.png" alt="wallet" />
      </div>
    </div>
  );
};

export default WalletCard;
